var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data.roles),function(role){return _c('a',{key:`tag-role-${role._id}`,staticClass:"underline cursor-pointer",on:{"click":function($event){return _vm.$router.push(`/admin/roles/${role._id}`)}}},[_vm._v(_vm._s(role.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }